/* Each element owns its timers and listeners, including during theme editor reloads. */
(() => {
  if (!customElements.get('nomosu-slider')) {
    customElements.define('nomosu-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const on = (target, event, handler) => target.addEventListener(event, handler, { signal: this.events.signal });
        this.track = this.querySelector(this.dataset.track);
        if (!this.track) return;
        this.slides = [...this.track.children].filter(el => !el.hasAttribute('data-slider-clone'));
        this.index = 0;
        this.selected = false;
        this.hovered = false;
        on(window, 'resize', () => this.setup());
        on(this, 'keydown', event => {
          if (!this.active || this.slides.length < 2 || !['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target.closest('input, textarea, select')) return;
          event.preventDefault();
          this.stop();
          this.show((this.index + (event.key === 'ArrowRight' ? 1 : -1) + this.slides.length) % this.slides.length, !matchMedia('(prefers-reduced-motion: reduce)').matches);
        });
        let touchStart = null;
        on(this, 'touchstart', event => { touchStart = event.touches[0]?.clientX; this.stop(); });
        on(this, 'touchend', event => {
          const distance = touchStart == null ? 0 : (event.changedTouches[0]?.clientX || 0) - touchStart;
          if (this.active && this.slides.length > 1 && Math.abs(distance) > 40) this.show((this.index + (distance < 0 ? 1 : -1) + this.slides.length) % this.slides.length, !matchMedia('(prefers-reduced-motion: reduce)').matches);
          touchStart = null;
          this.start();
        });
        on(document, 'visibilitychange', () => this.start());
        on(this, 'mouseenter', () => { this.hovered = true; this.stop(); });
        on(this, 'mouseleave', () => { this.hovered = false; this.start(); });
        on(this, 'focusin', () => this.stop());
        on(this, 'focusout', () => queueMicrotask(() => this.start()));
        on(document, 'shopify:block:select', event => {
          if (event.target !== document && !this.contains(event.target)) return;
          const index = this.slides.findIndex(el => el.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.selected = true;
          this.stop();
          this.show(index, false);
        });
        on(document, 'shopify:block:deselect', event => {
          if (event.target !== document && !this.contains(event.target)) return;
          if (!this.slides.some(el => el.dataset.blockId === event.detail?.blockId)) return;
          this.selected = false;
          this.start();
        });
        this.setup();
      }
      setup() {
        this.stop();
        this.track.querySelectorAll('[data-slider-clone]').forEach(el => el.remove());
        this.active = !this.dataset.mobileOnly || window.innerWidth <= 768;
        if (this.active && this.slides.length > 1) {
          const clone = this.slides[0].cloneNode(true);
          clone.setAttribute('data-slider-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          [clone, ...clone.querySelectorAll('*')].forEach(el => {
            el.removeAttribute('id'); el.removeAttribute('data-shopify-editor-block'); el.removeAttribute('data-block-id');
          });
          this.track.append(clone);
        }
        this.show(this.index % Math.max(1, this.slides.length), false);
        this.start();
      }
      show(index, animate = true) {
        clearTimeout(this.resetTimer);
        this.index = index;
        this.track.style.transition = animate ? 'transform .8s ease' : 'none';
        this.track.style.transform = this.active ? `translateX(-${index * 100}%)` : '';
        this.slides.forEach((slide, i) => {
          slide.inert = this.active && i !== index % this.slides.length;
          if (this.active && i !== index % this.slides.length) slide.setAttribute('aria-hidden', 'true');
          else slide.removeAttribute('aria-hidden');
        });
        if (index === this.slides.length) {
          this.resetTimer = setTimeout(() => this.show(0, false), 810);
        }
      }
      stop() { clearInterval(this.timer); clearTimeout(this.resetTimer); }
      start() {
        this.stop();
        if (!this.active || this.slides.length < 2 || this.selected || this.hovered || this.contains(document.activeElement) || document.hidden || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        // A pause during the loop transition must not leave the track beyond the last slide.
        if (this.index >= this.slides.length) this.show(0, false);
        this.timer = setInterval(() => this.show(this.index + 1), Math.max(2, Number(this.dataset.seconds) || 3) * 1000);
      }
      disconnectedCallback() {
        this.stop();
        this.events?.abort();
        this.events = null;
        this.track?.querySelectorAll('[data-slider-clone]').forEach(el => el.remove());
      }
    });
  }
  if (!window.nomosuEditorCardSelection) {
    window.nomosuEditorCardSelection = true;
    document.addEventListener('shopify:block:select', event => event.target?.closest?.('.multisensory-item')?.classList.add('is-editor-selected'));
    document.addEventListener('shopify:block:deselect', event => event.target?.closest?.('.multisensory-item')?.classList.remove('is-editor-selected'));
  }
})();
